import { Note } from "../note/Note"

export class QuotePartDetails {
  id: number
  displayOrder: number
  name: string
  notes: Note[]
  price: number

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, displayOrder: number, name: string, notes: any, price: number) {
    this.id = id
    this.displayOrder = displayOrder
    this.name = name
    this.price = price
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notes ? notes.map((n: any) => new Note(n.id, n.content, n.customerVisible, n.lastModifiedByUser, n.lastModifiedDate)) : []
  }
}